import * as React from 'react';
import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Badge, Card, Stack } from 'react-bootstrap';
import styles from './user-overview-card.module.sass';
import { ProjectLogo } from '@yakoffice/shared-components';

export interface UserOverviewCardProps {
    email: string;
    hasAdminPermissions: boolean;
    projects: ProjectData[];
    active?: boolean;
}

export interface ProjectData {
    hasClaims: boolean;
    claimType: string;
    logoSrc: string;
}

export const UserOverviewCard: FC<UserOverviewCardProps> = observer((props: UserOverviewCardProps) => {

    const name = () => {
        const nameReplace = props.email.substring(0, props.email.lastIndexOf('@'));
        const nameString = nameReplace.replace('.', ' ');
        return nameString !== props.email ? nameString : props.email;
    };

    const adminRole = () => {

        if (props.hasAdminPermissions)
            return <Badge pill bg="danger" className={styles.iamRoleBadge}><i
                className="fas fa-unlock-alt" /> User Admin</Badge>;
        else
            return null;
    };

    return (
        <Card key={props.email} className={`${styles.userOverviewCard} ${props.active ? 'active' : ''}`}>
            <Card.Body className={styles.cardBody}>
                <Card.Title className={styles.cardTitle}>
                    {name()}
                    {adminRole()}
                </Card.Title>
                <Card.Subtitle className={styles.cardSubtitle}>{props.email}</Card.Subtitle>

                <div className={styles.horizontalListItems}>
                    <Stack direction="horizontal" gap={2}>
                        {props.projects.map(project =>
                            project.hasClaims &&
                            <div className={styles.horizontalListItem}>
                                <ProjectLogo src={project.logoSrc} />
                                <span>{project.claimType}</span>
                            </div>
                        )}
                    </Stack>
                </div>
            </Card.Body>
        </Card>
    );
});
